// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__TDhqn","Cancel":"schedule_Cancel__wim3m"};